/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum ObjectFitEnum {
    NONE = 'NONE',
    AUTO = 'AUTO',
    FULL_WIDTH = 'FULL_WIDTH',
    CONTAIN = 'CONTAIN',
    COVER = 'COVER',
}